/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

// fitinsur API functions - 2019

import React from 'react';

class FitinsurAPI {

    constructor(props){
        //console.log("FitinsurAPI.constructor");
        this.username = String("");
        this.fit_auth_status = Boolean(false);
        this.fit_auth_token = null;
        //this.baseurl = String("https://localhost:8081/fitinsur/mockapp/service"); 
        //this.baseurl = String("https://developer.fitinsur.com.br/fitinsur/mockapp/service");
		this.baseurl = String(process.env.REACT_APP_FITINSUR_API_URL_MOCKUP);
    }

    requestLogin(username, password){
        console.log("FitinsurAPI.requestLogin - BEGIN");
        this.requestName = "/login";
        
        let bodyData = {
            action: "login",
            username: username,
            password: password
        };

        console.log("FitinsurAPI.requestLogin - END");

        return this.httpRequestPost(this.baseurl+this.requestName, bodyData, null);
    }    

    requestForgotPassword(username){
        console.log("FitinsurAPI.requestForgotPassword - BEGIN");
        this.requestName = "/login";
        
        let bodyData = {
            action: "forgotpw",
            username: username,
            password: ""
        };

        console.log("FitinsurAPI.requestForgotPassword - END");

        return this.httpRequestPost(this.baseurl+this.requestName, bodyData, this.fit_auth_token);
    }        

    requestChangePassword(username, password){
        console.log("FitinsurAPI.requestChangePassword - BEGIN");
        this.requestName = "/login";
        
        let bodyData = {
            action: "changepw",
            username: username,
            password: password
        };

        console.log("FitinsurAPI.requestChangePassword - END");

        return this.httpRequestPost(this.baseurl+this.requestName, bodyData, this.fit_auth_token);
    }    

    requestAccess(username, dsDomPrivilege, idDomain, idPersonRelation, idOperation){
        console.log("FitinsurAPI.requestAccess - BEGIN");
        this.requestName = "/access";

        let bodyData = {
            username: username,
            dsDomPrivilege: dsDomPrivilege,
            idDomain: idDomain,
            idPersonRelation: idPersonRelation,
            idOperation: idOperation
        };

        console.log("FitinsurAPI.requestAccess - END");

        return this.httpRequestPost(this.baseurl+this.requestName, bodyData, this.fit_auth_token);
    }

    httpRequestPost(endpoint, requestBody, token){
        return fetch(endpoint, {
            method: 'POST',
            headers: {
                'Content-Type':'application/json',
                'Authorization': token,
                'fit-auth-token': token,
            },
            body: JSON.stringify(requestBody)
        });
    }

    httpRequestGet(endpoint, requestBody, token){
        return fetch(endpoint, {
            method: 'GET',
            headers: {
                'Content-Type':'application/json',
                'Authorization': token,
                'fit-auth-token': token
            }
        });
    }
    
    httpRequestDelete(endpoint, requestBody, token){
        return fetch(endpoint, {
            method: 'DELETE',
            headers: {
                'Content-Type':'application/json',
                'Authorization': token,
                'fit-auth-token': token
            },
            body: JSON.stringify(requestBody)
        });
    }    

    setAuthToken(token){
        this.fit_auth_token=token;
    }

    requestListAction(token){
        console.log("FitinsurAPI.requestListAction - BEGIN");
        this.requestName = "/quote/list";
        
        let bodyData = { };

        console.log("FitinsurAPI.requestLogin - END");

        return this.httpRequestGet(this.baseurl+this.requestName, null, token);
    }
    
    requestLostDealList(token){
        this.requestName = "/query";
        
        let bodyData = { 
            id: "fitGetLostReason",
            params: {}
        };

        return this.httpRequestPost(this.baseurl+this.requestName, bodyData, token);
    }

    requestBrokerList(token){
        this.requestName = "/query";
        
        let bodyData = { 
            id: "fitGetBrokerList",
            params: {}
        };

        return this.httpRequestPost(this.baseurl+this.requestName, bodyData, token);
    }

    updateQuoteEdit(body,token){
        console.log("FitinsurAPI.updateQuoteEdit - BEGIN");
        this.requestName = "/quote/edit";
        console.log("FitinsurAPI.updateQuoteEdit - END");

        return this.httpRequestPost(this.baseurl+this.requestName, body, token);
    }  
    
    requestQuoteAdd(productId){
        this.requestName = "/add/list/" + productId;
        
        let bodyData = { 
           
        };

        return this.httpRequestGet(this.baseurl+this.requestName,bodyData, /* bodyData, */ this.fit_auth_token);
    }

    requestPersonList(body){
        this.requestName = "/query";
        console.log("valor do body: ", body)
        let bodyData = { 
            id: "fitQueryPerson",
            params: {
                personName:`${body}`
            }
        };

        return this.httpRequestPost("https://developer.fitinsur.com.br:30443/fitinsur/mockapp/service"+this.requestName, bodyData,this.fit_auth_token);
//        return this.httpRequestPost(this.baseurl+this.requestName, bodyData, token);
    }

    requestFileList(){
        this.requestName = "/quote/document";
        let bodyData = { 
                idOperation:8303,
                idTemplate:4
        };

        return this.httpRequestPost("http://localhost:8082/fitinsur/app/service"+this.requestName, bodyData, this.fit_auth_token);
    }

}

export default FitinsurAPI;